import { useAtomValue } from 'jotai'

import { NumberFieldInput } from '@sequencehq/core-components'

import { invoiceCurrencySymbolAtom } from 'Invoices/atoms/invoiceEditing.atom'
import { useCurrencyFormatting } from '../hooks/useCurrencyFormatting'
import { RateDisplay } from 'Invoices/types'

type Props = {
  value: string
  isDisabled?: boolean
  onChange: (value: string) => void
  rateDisplay: RateDisplay
  isInvalid: boolean
}

export const QuantityField = ({
  value,
  isDisabled = false,
  onChange,
  rateDisplay,
  isInvalid
}: Props) => {
  const currencySymbol = useAtomValue(invoiceCurrencySymbolAtom)

  const { handleBlur } = useCurrencyFormatting({
    value,
    onChange,
    rateDisplay,
    formatType: rateDisplay === 'PERCENTAGE' ? 'currency' : null
  })

  return (
    <NumberFieldInput
      textAlign="right"
      value={value}
      {...(isDisabled
        ? { isDisabled: true }
        : {
            placeholder: rateDisplay === 'ABSOLUTE' ? '0' : '0.00',
            prefix: rateDisplay === 'ABSOLUTE' ? undefined : currencySymbol,
            onChange: e => onChange(e.target.value),
            onBlur: handleBlur,
            isInvalid
          })}
    />
  )
}
